import { Content, Item, ItemTypeEnum, LessonPlan } from 'able-lib'

export const CONTENT_TEMPLATE: Content = {
  contentAssets: [],
  title: '',
  body: '',
  annotation: {}
}

export const LESSON_PLAN_TEMPLATE: LessonPlan = {
  assessment: null,
  enhancement: null,
  lesson: null,
  level: {
    id: null,
    name: null
  },
  number: null,
  objective: null,
  platform: null,
  resources: null,
  status: null,
  subject: {
    id: null,
    name: null
  },
  year: null
}

export const ITEM_LESSON_PLAN_TEMPLATE: Item = {
  type: ItemTypeEnum.LESSONPLAN,
  items: [],
  itemSettings: [],
  lessonPlan: LESSON_PLAN_TEMPLATE
}

export const ITEM_LESSON_TEMPLATE: Item = {
  type: ItemTypeEnum.LESSON,
  order: '1',
  content: CONTENT_TEMPLATE,
  items: [],
  itemUsers: [],
  itemGroups: [],
  itemSettings: [],
  startDateTime: new Date().getTime(),
  endDateTime: new Date().getTime() + (60 * 60 * 1000),
  originalItem: ITEM_LESSON_PLAN_TEMPLATE
}

export const ACTIVITY_TEMPLATE: Item = {
  type: ItemTypeEnum.CONTENT,
  order: '0',
  content: CONTENT_TEMPLATE,
  itemUsers: [],
  itemGroups: []
}
